import { createLoadActions } from '@copilot/common/store/actionCreators/list';
import { createFetchSaga } from '@copilot/common/store/saga';
import { MESSAGE_TEMPLATES } from './constant';
import { MessageTemplateModel } from '@copilot/common/pages/settings/template/data/models';

export const { listWatcher: watchLoadMessageTemplates, loadListAction: LoadMessageTemplatesAction } = createFetchSaga(
	MESSAGE_TEMPLATES,
	createLoadActions<MessageTemplateModel>(MESSAGE_TEMPLATES)
);
